<!-- Métodos de Pago -->
<label class="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Métodos de Pago</label>
<div class="flex flex-col sm:flex-row gap-2 mb-2">
  <app-select
    class="w-full"
    [options]="(optionsTipoPago$ | async) ?? []"
    [(value)]="selected_tipo_pago"
    placeholder="Seleccionar pago"
  />

  <div class="flex gap-2">
    <input
      type="number"
      placeholder="Monto"
      [(ngModel)]="monto_pago"
      class="flex-1 sm:w-28 border-gray-300 rounded px-2 sm:px-3 py-2 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
      (keydown.enter)="agregarPago()"
    />
    <button
      class="px-4 sm:px-3 py-2 rounded bg-blue-600 text-white font-bold text-lg flex items-center justify-center active:scale-95 min-w-12"
      (click)="agregarPago()"
    >
      +
    </button>
  </div>
</div>
